/**
 * Gives the homepage's principal link CTAs the same reliable held-down state
 * as a native button. The CSS :active selector remains as a no-JavaScript
 * fallback. Navigation is never intercepted or delayed.
 */
(() => {
  const selector = [
    "[id$='__hero_pMhJwX'] .hero__content-wrapper .group-block-content a:is(.button, .button-custom)",
    "[id$='__hero_anFhQK'] .hero__content-wrapper .group-block-content a:is(.button, .button-custom)",
  ].join(', ');
  const pressedClass = 'wf-cta-is-pressed';
  const pressedPointers = new Map();

  function findLink(target) {
    return target instanceof Element ? target.closest(selector) : null;
  }

  function showPressed(link) {
    link.classList.add(pressedClass);
  }

  function hidePressed(link) {
    link.classList.remove(pressedClass);
  }

  function releasePointer(event) {
    const link = pressedPointers.get(event.pointerId);
    pressedPointers.delete(event.pointerId);

    if (link) hidePressed(link);
  }

  function releaseAllPointers() {
    for (const link of pressedPointers.values()) hidePressed(link);
    pressedPointers.clear();
  }

  document.addEventListener(
    'pointerdown',
    (event) => {
      if (event.button !== 0 || event.isPrimary === false) {
        return;
      }

      const link = findLink(event.target);
      if (!link) return;

      pressedPointers.set(event.pointerId, link);
      showPressed(link);
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    'pointercancel',
    releasePointer,
    { passive: true, capture: true }
  );

  document.addEventListener(
    'pointerup',
    releasePointer,
    { passive: true, capture: true }
  );

  window.addEventListener('blur', releaseAllPointers);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) releaseAllPointers();
  });
})();
